/**
 * 任务分类推断（共享层）。
 * 根据 nodeType 或 service 名称推断任务所属的生成类型。
 */

export type TaskFilterCategory = 'all' | 'image' | 'video' | 'audio' | 'text';

export function resolveTaskCategory(service: string, nodeType?: string): TaskFilterCategory {
  if (nodeType) {
    const type = nodeType.toLowerCase();
    if (type === 'image' || type === 'video' || type === 'audio' || type === 'text') {
      return type as TaskFilterCategory;
    }
  }

  const lowerService = service.toLowerCase();
  if (lowerService.includes('video') || lowerService.includes('seedance') || lowerService.includes('v2v')) {
    return 'video';
  }
  if (lowerService.includes('audio') || lowerService.includes('voice') || lowerService.includes('music') || lowerService.includes('tts')) {
    return 'audio';
  }
  if (lowerService.includes('text') || lowerService.includes('llm') || lowerService.includes('script')) {
    return 'text';
  }
  return 'image';
}
